import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

export const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        zIndex: 9999,
        background: 'rgba(255,255,255,0.06)',
        pointerEvents: 'none',
      }}>
      <Box
        sx={{
          height: '100%',
          width: `${progress}%`,
          background:
            'linear-gradient(90deg, #e040fb 0%, #7c4dff 50%, #40c4ff 100%)',
          transition: 'width 0.1s linear',
          boxShadow: '0 0 8px rgba(224,64,251,0.6)',
        }}
      />
    </Box>
  );
};
